export default __webpack_public_path__ + "static/media/Letter N.6664426a.mov";